import React from "react";

import { IconChevron, Text } from "@busbud/horizon";

import { CustomNativeSelect } from "@app/components/custom-native-select";
import { useAppContext } from "@app/helpers/hooks";
import { redirect } from "@app/utils/window";

import type { Props } from "./account-navigation";

import { getMenuItems } from "./helpers/menu-items";
import { useIsAuthenticated } from "./use-is-authenticated";

export const AccountNavigationXs: React.FC<Props> = ({ current_page }) => {
  const { translator, urlBuilder } = useAppContext();
  const is_authenticated = useIsAuthenticated();

  const items = getMenuItems(translator, urlBuilder, is_authenticated);

  const item = items.find(item => item.isSelected(current_page));

  if (!item) {
    return null;
  }

  const handleRedirect = (e: { target: { value: string } }) => {
    if (e.target.value !== url) {
      redirect(e.target.value);
    }
  };

  const { Icon, label, url } = item;

  return (
    <CustomNativeSelect
      className="flex flex-col sm:hidden"
      onChange={handleRedirect}
      value={url}
      Trigger={
        <div className="whitespace-nowrap rounded-md border-width-sm border-solid border-color-primary px-300 py-150 text-color-tertiary">
          <div className="flex items-center justify-between gap-100">
            <div className="flex items-center gap-150">
              <Icon />
              <Text as="span" className="font-weight-bold" size="lg">
                {label}
              </Text>
            </div>
            <IconChevron size="md" variant="down" className="opacity-70" />
          </div>
        </div>
      }
    >
      {items.map(item => (
        <option key={item.label} value={item.url}>
          {item.label}
        </option>
      ))}
    </CustomNativeSelect>
  );
};
